import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { PeopleItem, KeyPartnerItem } from '../shared';
import { data, keyPartners } from '../data';

export class Investigators extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        let items = data.map((item, index) => { if (item.type === "people1") { return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; } });

        return (<section>
            <People1 />
            <People2 />
        </section>);
    }
}

export class People1 extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    
    render() {
        let items = data.map((item, index) => { if (item.type === "people1") { return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; } });

        return (<section className="base3-bg">
                        <div className="container pt-2 mb-4">
                        <h1>CHIEF INVESTIGATORS</h1>
                    </div>
                    {items}
                </section>);
    }
}



export class People2 extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        let items = data.map((item, index) => { if (item.type === "people2") { return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; } });

        return (<section className="base3-bg">

            <div className="container pt-2 mb-4">
                    <h1>ASSOCIATE INVESTIGATORS</h1>
                </div>
                {items}
            </section>);
    }
}


export class People3 extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        let items = data.map((item, index) => { if (item.type === "people3") { return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; } });

        return (<section className="base3-bg">

            <div className="container pt-2  mb-4">
                    <h1>STUDENTS AND TRAINEES</h1>
                </div>
            {items}
            </section>);
    }
}


export class People4 extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        let items = data.map((item, index) => { if (item.type === "people4") { return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; } });

        return (<section className="base3-bg">
            <div className="container pt-2 mb-4">
                    <h1>INDIGENOUS ADVISORY GROUP</h1>
                </div>
            {items}
            </section>);
    }
}

export class People5 extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        let items = data.map((item, index) => { if (item.type === "people5") { return <PeopleItem key={"people5Item" + index} {...item}></PeopleItem>; } });

        return (<section className="base3-bg">
            <div className="container pt-2 mb-4">
                    <h1>Early career</h1>
                </div>
            {items}
            </section>);
    }
}

export class Partners extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }
    

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        let teamItems = keyPartners.map((item, index) => { if (item.type === "team") { return <KeyPartnerItem key={"keyteam" + index} {...item}></KeyPartnerItem>; } });
        let auxItems = keyPartners.map((item, index) => { if (item.type === "aux") { return <KeyPartnerItem key={"keyaux" + index} {...item}></KeyPartnerItem>; } });
        return (<section className="">
                <div className="container pt-2 mb-4">
                    <h1>Key Partners</h1>
                </div>
                

                <div className="row pt-3 pb-3">
                    <div className="col-12">
                        <div className="container">
                            <div className="row">
                                <div className="col-6 col-md-3 text-center">
                                <a href="http://www.nhmrc.gov.au/" target="_blank"><img src={require("../assets/img/2.6_About-Us_Key-Partner_1_NHMRC.svg")} width="75%"
                                /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="row pt-3 pb-3">
                    <div className="col-12">
                        <div className="container">
                            <div className="row">
                                {teamItems}
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <div className="row pt-3 pb-3">
                    <div className="col-12">
                        <div className="container">
                            <div className="row">
                                {auxItems}
                            </div>
                        </div>
                    </div>
                </div>
        </section>);
    }
}


// WEBPACK FOOTER //
// ./src/pages/People1.tsx